import { useCallback, useEffect, useState } from "react";
import { fetchCategories } from "../lib/api";

export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const data = await fetchCategories();
      setCategories(data.categories || []);
    } finally {
      setLoading(false);
    }
  }, [setCategories, setLoading]);

  useEffect(() => { load(); }, [load]);

  return { categories, loading, reload: load };
};
